const BASE_URL = "https://app.redchilli.ai/api/admin";
const HOST = "https://app.redchilli.ai/";

export { BASE_URL, HOST };
